import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=8c47d19c&scoped=true&"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts&"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=8c47d19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c47d19c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c47d19c')) {
      api.createRecord('8c47d19c', component.options)
    } else {
      api.reload('8c47d19c', component.options)
    }
    module.hot.accept("./LanguageSelector.vue?vue&type=template&id=8c47d19c&scoped=true&", function () {
      api.rerender('8c47d19c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/LanguageSelector.vue"
export default component.exports